export interface NormalisedPostcode {
  postcode: string
  outwardCode: string
}

export function normaliseGbPostcode(input: unknown): NormalisedPostcode {
  if (typeof input !== "string") throw new Error("INVALID_POSTCODE")
  const compact = input.trim().toUpperCase().replace(/\s+/g, "")
  if (compact.length < 5 || compact.length > 7) throw new Error("INVALID_POSTCODE")
  const postcode = `${compact.slice(0, -3)} ${compact.slice(-3)}`
  if (!/^(GIR 0AA|[A-Z]{1,2}[0-9][0-9A-Z]? [0-9][A-Z]{2})$/.test(postcode)) {
    throw new Error("INVALID_POSTCODE")
  }
  return { postcode, outwardCode: postcode.split(" ")[0] }
}

